const ClubApi = {
    post(href, callback, body) {
        const params = {
            method: "POST",
            credentials: "include",
        };

        // Optional form body (e.g. the chosen reaction). URLSearchParams sets
        // Content-Type: application/x-www-form-urlencoded so Django parses it
        // into request.POST. Existing callers pass no body — unchanged.
        if (body) {
            params.body = new URLSearchParams(body);
        }

        fetch(href + "?is_ajax=true", params)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then((data) => callback(data))
            .catch((error) => {
                callback({ error: error.message });
            });
    },

    get(href, callback) {
        const params = {
            method: "GET",
            credentials: "include",
        };

        fetch(href + "?is_ajax=true", params)
            .then((response) => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then((data) => callback(data))
            .catch((error) => {
                callback({ error: error.message });
            });
    },
};

export default ClubApi;
